var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDueTodayKpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 39,
    viewBox: "0 0 46 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 751",
    d: "M34 0C27.9249 0 23 1.84203 23 4.11429V33.8857C23 36.158 27.9249 38 34 38C40.0751 38 45 36.158 45 33.8857V4.11429C45 1.84203 40.0751 0 34 0Z",
    fill: "#FC9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 754",
    d: "M45 27.3165C45 29.6191 40.0751 31.4857 34 31.4857C27.9249 31.4857 23 29.6191 23 27.3165",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 755",
    d: "M45 19.7166C45 21.4195 40.0751 22.8 34 22.8C27.9249 22.8 23 21.4195 23 19.7166",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 756",
    d: "M45 12.1166C45 13.8195 40.0751 15.2 34 15.2C27.9249 15.2 23 13.8195 23 12.1166",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 757",
    d: "M45 4.51648C45 6.21941 40.0751 7.59991 34 7.59991C27.9249 7.59991 23 6.21941 23 4.51648",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 750",
    d: "M12 16.2856C5.92487 16.2856 1 18.1522 1 20.4548V33.8308C1 36.1333 5.92487 37.9999 12 37.9999C18.0751 37.9999 23 36.1333 23 33.8308V20.4548C23 18.1522 18.0751 16.2856 12 16.2856Z",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 752",
    d: "M23 27.3165C23 29.6191 18.0751 31.4857 12 31.4857C5.92487 31.4857 1 29.6191 1 27.3165",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 753",
    d: "M23 19.7166C23 21.4195 18.0751 22.8 12 22.8C5.92487 22.8 1 21.4195 1 19.7166",
    stroke: "#383434",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDueTodayKpi);
export default __webpack_public_path__ + "static/media/due_Today_KPI.3da908374239570ad9a49fb6abe18bbe.svg";
export { ForwardRef as ReactComponent };